import { AppDispatch } from '../../../store'
import { API } from '../../../common/api'
import { labravAWSEngineServiceUrl } from '../../../common/utils/constants'

export enum otpActionTypes {
  SET_OTP_ROUTE_CONTEXT = 'SET_OTP_ROUTE_CONTEXT',
  REQUEST_OTP_START = 'REQUEST_OTP_START',
  REQUEST_OTP_SUCCESS = 'REQUEST_OTP_SUCCESS',
  REQUEST_OTP_ERROR = 'REQUEST_OTP_ERROR',
  RESEND_OTP_START = 'RESEND_OTP_START',
  RESEND_OTP_SUCCESS = 'RESEND_OTP_SUCCESS',
  RESEND_OTP_ERROR = 'RESEND_OTP_ERROR',
}

export type OtpRouteContext = {
  partnerId: string
  contactId: string
  invitationId: string
}

export const setOtpRouteContext = (context: OtpRouteContext) => ({
  type: otpActionTypes.SET_OTP_ROUTE_CONTEXT,
  payload: context,
})

const requestOtpStart = () => ({ type: otpActionTypes.REQUEST_OTP_START })
const requestOtpSuccess = () => ({ type: otpActionTypes.REQUEST_OTP_SUCCESS })
const requestOtpError = (message: string) => ({
  type: otpActionTypes.REQUEST_OTP_ERROR,
  payload: message,
})

const resendOtpStart = () => ({ type: otpActionTypes.RESEND_OTP_START })
const resendOtpSuccess = () => ({ type: otpActionTypes.RESEND_OTP_SUCCESS })
const resendOtpError = (message: string) => ({
  type: otpActionTypes.RESEND_OTP_ERROR,
  payload: message,
})

const getInvitationOtpUrl = (context: OtpRouteContext) =>
  `${labravAWSEngineServiceUrl}/partners/${context.partnerId}/contacts/${context.contactId}/collab-room/invitation_id=${context.invitationId}`

export const requestOtpForInvitation =
  (context: OtpRouteContext) => async (dispatch: AppDispatch) => {
    dispatch(requestOtpStart())
    try {
      await API.post(getInvitationOtpUrl(context))
      dispatch(requestOtpSuccess())
    } catch (error) {
      dispatch(requestOtpError('Unable to send OTP. Please try again.'))
    }
  }

export const resendOtpForInvitation =
  (context: OtpRouteContext) => async (dispatch: AppDispatch) => {
    dispatch(resendOtpStart())
    try {
      await API.post(getInvitationOtpUrl(context))
      dispatch(resendOtpSuccess())
    } catch (error) {
      dispatch(resendOtpError('Unable to resend OTP. Please try again.'))
    }
  }
